import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScenarioConsultationDrawer from './ScenarioConsultationDrawer';

interface ScenarioBottomCTAProps {
  selectedIndustry?: string;
  selectedMode?: string;
  selectedGoal?: string;
}

export default function ScenarioBottomCTA({ 
  selectedIndustry = '', 
  selectedMode = '', 
  selectedGoal = '' 
}: ScenarioBottomCTAProps) {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleConsultation = () => {
    setDrawerOpen(true);
  };

  return (
    <>
      <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          {/* 标题 */}
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            获取你的场景方案与起步报价
          </h2>
          <p className="text-gray-600 mb-10 max-w-2xl mx-auto">
            根据您的业务形态与管理需求，我们将为您匹配最适合的合规方案组合
          </p>

          {/* CTA按钮组 */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={handleConsultation}
              className="w-full sm:w-auto px-8 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg shadow-teal-600/20"
            >
              咨询方案
            </button>

            <button
              onClick={() => navigate('/capabilities')}
              className="w-full sm:w-auto px-8 py-3 bg-white border-2 border-gray-900 text-gray-900 font-medium rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看产品及价格
            </button>

            <button
              onClick={() => navigate('/capabilities')}
              className="w-full sm:w-auto px-6 py-3 text-teal-600 font-medium hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer underline"
            >
              先跑通一票（9.9/99）
            </button>
          </div>

          {/* 专业口径声明 */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <p className="text-sm text-gray-700 leading-relaxed">
              星贸云提供资料归集、校验留痕与流程管理能力，不承诺通关、退税或审批结果。
              <br />
              服务包为叠加项，适用范围以合同约定为准。
            </p>
          </div>
        </div>
      </section>

      <ScenarioConsultationDrawer 
        isOpen={drawerOpen} 
        onClose={() => setDrawerOpen(false)}
        selectedIndustry={selectedIndustry}
        selectedMode={selectedMode}
        selectedGoal={selectedGoal}
      />
    </>
  );
}